import React, { Component } from 'react';
import axios from 'axios';
import Thanks from './../../../components/Thanks';
import { Input, Textarea } from './../../../components/forms/input';
import Head from 'next/head';
class CustomProposal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
      budget: 0,
      plan: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.hideThanksModal = this.hideThanksModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  handleChange(param, value) {
    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }
  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
    });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    location.reload();
  }
  onSubmit(e) {
    e.preventDefault();
    let that = this;
    let form_data = new FormData();
    for (var key in this.state.formdata) {
      form_data.append(key, this.state.formdata[key]);
    }
    form_data.append('country', this.props.country);
    form_data.append('budget', this.state.budget);
    form_data.append(
      'service',
      this.state.plan == '1'
        ? 'Plan For Start Growth'
        : this.state.plan == '2'
          ? 'Plan for Fast Growth'
          : this.state.plan == '3'
            ? 'Plan for Ultra Growth'
            : 'Paid Advertising'
    );
    // that.setState({ showThanks: true });
    document.body.style.overflow = 'hidden';

    axios.post('https://mailer.weprodigi.com/api/v1/get-custum-proposal', form_data).then(response => {
      // that.setState({ loadedThanks: true });
      window.location.href = 'https://weprodigi.com/thank-you';
    });
  }
  componentDidMount() {
    let arr = new URL(location.href).searchParams;
    this.setState({ budget: arr.get('budget'), plan: arr.get('plan') });
  }
  render() {
    return (
      <>
        <Head>
          <title>Paid Advertising Services | Custom Proposal - WeProdigi</title>
          <link rel="alternate" hrefLang="en" href="https://weprodigi.com/paid-advertising-services/custom-proposal" />
          <meta
            name="description"
            content="Request a customized proposal for our paid advertising services. Achieve your marketing goals with targeted advertising solutions from WeProdigi."
          />
          <meta property="og:url" content="https://weprodigi.com/paid-advertising-services/custom-proposal" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Paid Advertising Services | Custom Proposal - WeProdigi" />
          <meta
            property="og:description"
            content="Request a customized proposal for our paid advertising services. Achieve your marketing goals with targeted advertising solutions from WeProdigi."
          />
        </Head>
        <style global jsx>{`
          .bg-image {
            background-size: cover;
            background-image: url('/images/about/main-image-positions.png');
            background-position: center;
          }
        `}</style>
        <div className="relative w-full  h-300  overflow-hidden  bg-grid">
          <div className="container h-full">
            <div className="relative h-full  flex flex-col flex-wrap justify-center items-start ">
              <h1 className="flex flex-col flex-wrap justify-center items-start">
                <div className="uppercase text-purple text-36 md:text-72 font-black leading-none">get a</div>
                <div className="uppercase text-purple text-36 md:text-72 font-black leading-none">custom</div>
                <div className="uppercase text-purple text-36 md:text-72 font-black leading-none">proposal</div>
              </h1>
              <div className="text-black text-24 md:text-36 font-black mt-10 max-w-450 uppercase"> paid ADVERTISING </div>
            </div>
          </div>
        </div>
        <div className="bg-white py-30">
          <div className="container">
            <form>
              <div className="mt-20">
                <p className="text-14 mb-5 text-purple font-bolder">Select Your Business Goal</p>
                <div className=" my-20 flex-wrap">
                  <div className="form-group mr-5  ml-10">
                    <label className="relative pl-30 mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('goal', 'Want to drive more leads')}
                        type="radio"
                        name="service"
                        value="Video Production"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Want to drive more leads
                    </label>
                  </div>
                  <div className="form-group mr-5  ml-10">
                    <label className="relative pl-30  mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('goal', 'Want to earn more online sales')}
                        type="radio"
                        name="service"
                        value="Social Media Marketing"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Want to earn more online sales
                    </label>
                  </div>
                  <div className="form-group mr-5  ml-10">
                    <label className="relative pl-30 mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('goal', 'Want to improve my ROI')}
                        type="radio"
                        name="service"
                        value="Paid Advertising Services"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Want to improve my ROI
                    </label>
                  </div>
                  <div className="form-group mr-5  ml-10">
                    <label className="relative pl-30  mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('goal', 'Other')}
                        type="radio"
                        name="service"
                        value="Website Development"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Other
                    </label>
                  </div>
                </div>
                <div className="mb-10">
                  <p className="text-14 mb-5 text-purple font-bolder">Is there anything specific we should know about your project?</p>
                  <div className="mb-10">
                    <Textarea
                      type="text"
                      name="description"
                      bg="bg-gray-light resize-none"
                      required={false}
                      rows={4}
                      placeholder=""
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="mb-10">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Company Name*</p>
                      <div className="mb-10">
                        <Input type="text" name="company-name" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14  mb-5 text-purple font-bolder">Company Website*</p>
                      <div className="mb-10">
                        <Input type="text" name="website" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-10">
                  <div className="md:grid grid-cols-3 gap-10">
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Your Name *</p>
                      <div className="mb-10">
                        <Input type="text" name="name" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Your Email *</p>
                      <div className="mb-10">
                        <Input type="text" name="email" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Your Phone Number *</p>
                      <div className="mb-10">
                        <Input type="number" name="phone-number" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row my-10">
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-black text-14 md:text-18 flex items-center">
                      <input
                        id="nda"
                        className="absolute cursor-pointer opacity-0"
                        onChange={e => this.handleChange('nda', e.target.checked ? 'yes' : 'No')}
                        type="checkbox"
                        name="nda"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-black rounded-sm" />
                      Send NDA
                    </label>
                  </div>
                </div>
                <input type="hidden" name="country" value={this.props.country} />
                <div className="col-span-2">
                  <button
                    id="offer-submit"
                    type="button"
                    className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block "
                    onClick={this.onSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal}>
          Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from
          us within 24 hours please check your Spam Box.
        </Thanks>
      </>
    );
  }
}
export default CustomProposal;
